import { render, staticRenderFns } from "./FarmCardItem.vue?vue&type=template&id=472187d2&scoped=true&"
import script from "./FarmCardItem.vue?vue&type=script&lang=js&"
export * from "./FarmCardItem.vue?vue&type=script&lang=js&"
import style0 from "./FarmCardItem.vue?vue&type=style&index=0&id=472187d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472187d2",
  null
  
)

export default component.exports